// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flags .small[data-v-4c73bde8]{padding-bottom:10px}", "",{"version":3,"sources":["webpack://./app/scripts/vue/jobs/new/SystemMpptFlags.vue"],"names":[],"mappings":"AAEI,+BACI,mBADR","sourcesContent":["\n.flags {\n    .small {\n        padding-bottom: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
